<template>
  <div>
    <b-card no-body>
      <b-card-body class="px-1 pt-1 pb-0">
        <b-row>
          <b-col xl="3" md="6">
            <label for="idcliente">Cliente</label>
            <v-select id="idcliente" v-model="clienteSelected" :options="clienteOpt" @input="filtrar()"
              :reduce="clienteOpt => clienteOpt.value" label="text" key="value" placeholder="Seleccionar..."
              class="select-size-sm mt-0">
              <span slot="no-options"> Sin datos</span>

            </v-select>
          </b-col>
          <b-col xl="3" md="6">
            <label for="idcultivo">Cultivo</label>
            <v-select id="idcultivo" v-model="cultivoSelected" :options="cultivoOpt" @input="filtrar()"
              :reduce="cultivoOpt => cultivoOpt.value" label="text" key="value" placeholder="Seleccionar..."
              class="select-size-sm mt-0">
              <span slot="no-options"> Sin datos</span>

            </v-select>
          </b-col>
          <b-col xl="3" md="6">
            <label for="idsemana">Semana</label>
            <v-select id="idsemana" v-model="semanaSelected" :options="semanaOpt" :reduce="semanaOpt => semanaOpt.value"
              @input="filtrar()" label="text" key="value" placeholder="Seleccionar..." class="select-size-sm mt-0">
              <span slot="no-options"> Sin datos</span>

            </v-select>
          </b-col>
          <b-col xl="3" md="6">
            <label for="idzona">Zona</label>
            <v-select id="idzona" v-model="zonaSelected" :options="zonaOpt" :reduce="zonaOpt => zonaOpt.value"
              @input="filtrar()" label="text" key="value" placeholder="Seleccionar..." class="select-size-sm mt-0">
              <span slot="no-options"> Sin datos</span>

            </v-select>
          </b-col>
          <!-- <b-col xl="2">
            <label>&nbsp;</label>
            <br>
            <b-button variant="gradient-primary" size="sm" @click="traerShippingAdvice('');">
              <feather-icon icon="PlusIcon" />
              <span class="align-middle">Filtrar</span>
            </b-button>
          </b-col> -->

        </b-row>
      </b-card-body>
      <hr class="invoice-spacing pt-0 pb-0">
      <b-card-body class="px-1 pt-0 pb-0">
        <b-row>

          <b-col xl="4" lg="4" md="6" sm="12" class="text-left mb-1">
            <b-button-group>
              <b-button @click="traerShippingAdvice" :disabled="loading" size="sm" v-b-tooltip.hover
                title="Actualizar datos" variant="gradient-primary" class="mr-1">
                <feather-icon icon="RefreshCwIcon" :class="`${loading ? 'spinner' : ''}`" />
              </b-button>
            </b-button-group>
            <b-button-group>
              <b-button @click="mostrarModal" :disabled="loadingCorreo" size="sm" v-b-tooltip.hover
                title="Enviar datos por correo" variant="gradient-success" class="mr-1">
                <span v-if="!loadingCorreo && !filtrando">Enviar&emsp;</span>
                <span v-if="loadingCorreo"> Enviando correo...
                  <b-spinner style="width: 16px; height: 16px;" />
                </span>
                <span v-if="filtrando"> Espere, Cargando Data...
                  <b-spinner style="width: 16px; height: 16px;" />
                </span>
                <feather-icon v-else icon="ArrowUpCircleIcon" />
              </b-button>
            </b-button-group>
          </b-col>

          <b-col xl="4" lg="4" md="6" sm="12" class="text-center mb-1 font-medium-1 text-bold font-weight-bold">
            Mostrando {{ items.length === 1 ? "1 registro" : items.length + " registros" }}.
          </b-col>

          <b-col xl="4" lg="4" md="6" sm="12" class="text-right mb-1">
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group>
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar" size="sm" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''" size="sm">
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </b-card-body>


      <b-table v-if="$can('read', 'Shipping Advice')" ref="tablesa" responsive hover sticky-header="58vh"
        class="position-relative" :items="items" :fields="sortable_cols" :filter="filter"
        :filter-included-fields="filterOn" :busy="loading" show-empty
        empty-text="No se encontraron datos en esta tabla."
        emptyFilteredText="No se encontraron datos con los parámetros ingresados.">
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>
      </b-table>
      <b-modal id="modalRegistro" v-model="estadoModal" :title="infoModal.title" :ok-title="infoModal.boton"
        cancel-variant="outline-secondary" cancel-title="Cancelar" @hidden="resetModal" @ok="okModal" centered
        size="lg">
        <form ref="form" @submit.stop.prevent="enviarFormulario">
          <b-row>
            <b-col sm="8">
              <b-form-group :state="validacion" label="Correo" label-for="idcorreo">
                <b-form-input v-if="checkbox" id="idCorreosSelected" placeholder="Ingrese Correo No Registrado"
                  v-model="correoSelected" :state="validacion" type="text" size="sm" required />

                <v-select v-else id="idCorreosSelected" v-model="correoSelected" :options="emailOpt"
                  :reduce="emailOpt => emailOpt.value" label="text" key="value" class="select-size-sm mt-0">
                  <span slot="no-options"> Sin datos</span>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group label="Otro">
                <b-form-checkbox v-model="checkbox" class="mr-0 mt-30" switch inline />
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group v-if="checkbox" class="float-right">
                <label>&nbsp;</label>
                <br>
                <b-button variant="gradient-warning" size="sm" @click="agregarCorreo();">
                  <feather-icon icon="PlusCircleIcon" />
                </b-button>
              </b-form-group>
            </b-col>

            <b-col sm="10">
              <b-form-group label="Destinatarios" label-for="iddestinatarios" invalid-feedback="Correo es requerido">
                <v-select id="iddestinatarios" v-model="destinosSelected" :options="destinosOpt"
                  :reduce="destinosOpt => destinosOpt.value" label="text" key="value" class="select-size-sm mt-0"
                  required :state="validacion">
                  <span slot="no-options"> Sin datos</span>

                </v-select>

              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group class="float-right">
                <label>&nbsp;</label>
                <br>
                <b-button variant="gradient-danger" size="sm" @click="eliminarCorreo();">
                  <feather-icon icon="Trash2Icon" />

                </b-button>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :state="validacion" label="Asunto" label-for="idasunto"
                invalid-feedback="Asunto es requerido">
                <b-form-input id="idasunto" placeholder="Asunto" v-model="asunto" :state="validacion" type="text"
                  size="sm" required />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :state="validacion" label="Contenido" label-for="idcontenido"
                invalid-feedback="Contenido es requerido">
                <b-form-textarea id="idcontenido" v-model="contenido" placeholder="Ingresar contenido" rows="12"
                  :state="validacion" required />
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group :state="validacion" label="Nombres Remitente" label-for="idnombresremitente"
                invalid-feedback="Nombres es requerido">
                <b-form-input id="idnombresremitente" placeholder="Nombres del remitente" v-model="nomnbres_remitente"
                  :state="validacion" type="text" size="sm" required />
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group :state="validacion" label="Apellidos Remitente" label-for="idapellidos"
                invalid-feedback="Apellidos es requerido">
                <b-form-input id="idapellidos" placeholder="Ingrese Apellidos" v-model="apellidos_remitente"
                  :state="validacion" type="text" size="sm" required />
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group :state="validacion" label="Teléfono Remitente" label-for="idnombresremitente"
                invalid-feedback="Teléfono es requerido">
                <b-form-input id="idtelefonoremitente" placeholder="Teléfono del remitente" v-model="telefono"
                  :state="validacion" type="text" size="sm" required />
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="6">
              <b-form-group :state="validacion" label="Correo Remitente" label-for="idcorreoremitente"
                invalid-feedback="Correo remitente es requerido">
                <b-form-input id="idcorreoremitente" placeholder="Correo remitente" v-model="correo_remitente"
                  :state="validacion" type="email" size="sm" required />
              </b-form-group>
            </b-col> -->
          </b-row>
        </form>
      </b-modal>
      <div style="display: none" v-html="miHtml">

      </div>
    </b-card>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'


import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { required, integer, length, max } from '@validations'
import VueContext from 'vue-context'
import {
  BCard, BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BTooltip,
  BModal, VBModal, BListGroup, BListGroupItem, BRow, BCol, BFormFile, BFormTextarea, BSpinner, BButtonGroup, BSidebar, VBToggle,
  BCardText, BForm, BFormDatepicker, BLink, BInputGroupPrepend, BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader, BDropdownDivider,
  BFormCheckbox, VBTooltip
} from 'bootstrap-vue'
import { heightFade } from '@core/directives/animations'
import flatPickr from 'vue-flatpickr-component'
import { Modal, Button } from 'bootstrap'


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VueContext,
    BCard,
    BTable, BFormCheckbox,
    BLink,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    VuePerfectScrollbar,
    ToastificationContent,
    BFormFile,
    BFormTextarea, BSpinner, BButtonGroup,
    BSidebar,
    BFormDatepicker, BInputGroupPrepend, BForm,
    BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader, BDropdownDivider,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    'modal': Modal,
    'height-fade': heightFade,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data: () => ({
    y: 0,
    checkbox: false,
    loading: false,
    loadingCorreo: false,
    filtrando: false,
    items: [],
    correosAll: [],
    filter: null,
    filterOn: [],
    estadoModal: false,
    infoModal: {
      title: '',
      boton: '',
    },
    fields: [
      {
        key: 'cultivo',
        label: 'cultivo',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'expo_ref',
        label: 'expo_ref',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'customer',
        label: 'customer',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'consignee',
        label: 'consignee',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'customer_reference_po',
        label: 'customer_reference_po',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'contenedor_awb',
        label: 'contenedor_awb',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'booking',
        label: 'booking',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'bl',
        label: 'bl',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'pol_loaded_port',
        label: 'pol_loaded_port',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'pod_discharge_port',
        label: 'pod_discharge_port',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'shipping_line',
        label: 'shipping_line',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'vessel',
        label: 'vessel',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'n_vessel',
        label: 'n_vessel',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'week_etd',
        label: 'week_etd',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'etd',
        label: 'etd',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'week_eta',
        label: 'week_eta',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'eta',
        label: 'eta',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'eta_real',
        label: 'eta_real',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'pack_style',
        label: 'pack_style',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'variedad',
        label: 'variedad',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'total_boxes',
        label: 'total_boxes',
        tdClass: 'alinear-una-sola-linea'
      },
      {
        key: 'n_fcl',
        label: 'n_fcl',
        tdClass: 'alinear-una-sola-linea'
      },
    ],
    status: [
      {
        0: 'Activo',
        1: 'Inactivo',
      },
      {
        0: 'light-success',
        1: 'light-danger',
      }
    ],

    clienteOpt: [],
    clienteSelected: '',
    emailOpt: [],
    correoSelected: '',
    cultivoOpt: [],
    cultivoSelected: '',
    semanaOpt: [],
    semanaSelected: '',
    zonaOpt: [],
    zonaSelected: '',
    validacion: null,
    destinosSelected: null,
    destinosOpt: [],
    correo: '',
    contenido: "",
    // nomnbres_remitente: '',
    // telefono: '',
    // correo_remitente: '',
    // apellidos_remitente: '',
    asunto: '',

    miHtml: '',


  }),
  computed: {
    sortable_cols() {
      return this.fields.map(f => {
        let tmp = f;
        tmp.sortable = true;
        return tmp
      })

    }
  },
  mounted() {
    this.traerFiltros();
    this.traerShippingAdvice('INI');
  },
  methods: {
    filtrar() {
      // console.log(this.clienteSelected, " ", this.cultivoSelected, " ", this.semanaSelected, " ", this.zonaSelected);
      this.traerShippingAdvice('Filtro')
    },
    traerFiltros() {
      let yo = this;
      yo.clienteOpt = [];
      yo.cultivoOpt = [];
      yo.semanaOpt = [];
      yo.zonaOpt = [];
      const config = {
        method: 'get',
        url: '/comex/filtros_shipping/'
      }
      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            for (let value of response.data['Clientes']) {
              if (value.customer != null && value.customer !== '' && value.customer !== ' ' && value.customer !== '  ') {
                yo.clienteOpt.push({ value: value.customer, text: value.customer })
              }
            }
            yo.clienteOpt.unshift({ value: 'T', text: "TODOS" });
            yo.clienteSelected = "T";
            for (let value of response.data['Cultivos']) {
              if (value.cultivo != null && value.cultivo !== '' && value.cultivo !== ' ' && value.cultivo !== '  ') {
                yo.cultivoOpt.push({ value: value.cultivo, text: value.cultivo })
              }
            }
            yo.cultivoOpt.unshift({ value: 'T', text: "TODOS" });
            yo.cultivoSelected = "T";
            for (let value of response.data['Semanas']) {
              if (value.week_eta != null && value.week_eta !== '' && value.week_eta !== ' ' && value.week_eta !== '  ') {
                yo.semanaOpt.push({ value: value.week_eta, text: value.week_eta })
              }
            }
            yo.semanaOpt.unshift({ value: 'T', text: "TODOS" });
            yo.semanaSelected = "T";
            for (let value of response.data['Zonas']) {
              if (value.zona_venta != null && value.zona_venta !== '' && value.zona_venta !== ' ' && value.zona_venta !== '  ') {
                yo.zonaOpt.push({ value: value.zona_venta, text: value.zona_venta })
              }
            }
            yo.zonaOpt.unshift({ value: 'T', text: "TODOS" });
            yo.zonaSelected = "T";
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading = false
          yo.filtrando = false
        })


    },
    traerShippingAdvice(type) {
      this.destinosOpt = []
      const yo = this
      yo.loading = true
      yo.filtrando = true
      var cliente = yo.clienteSelected;
      var cultivo = yo.cultivoSelected;
      var semana = yo.semanaSelected;
      var zona = yo.zonaSelected;
      if (cliente == '') cliente = 'T';
      if (cultivo == '') cultivo = 'T';
      if (semana == '') semana = 'T';
      if (zona == '') zona = 'T';
      const url = `/comex/shippingadvice/${cliente}/${cultivo}/${semana}/${zona}`;
      const config = {
        method: 'get',
        // url: '/shippingadvice/?' + getFiltro
        url: url
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            yo.items = response.data
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading = false
          yo.filtrando = false
          if (type == "INI" || type == "") {
            yo.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Correcto`,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: `Los Datos se Cargaron Correctamente`,
              },
            })
          } else {
            yo.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Correcto`,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: `Filtro Aplicado Correctamente`,
              },
            })
          }
        })


      const rpta = {
        method: 'get',
        url: '/comex/emails_clients/' + cliente
      }
      axiosIns(rpta)
        .then(function (response) {
          if (response.status === 200) {
            yo.correosAll = response.data
            if (yo.clienteSelected != null && yo.clienteSelected !== '' && yo.clienteSelected !== ' ' && yo.clienteSelected !== '  ' && yo.clienteSelected !== 'T') {
              for (let value of yo.correosAll) {
                yo.destinosOpt.push({ value: value.correo_oficial, text: value.correo_oficial })
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })

    },
    mostrarModal() {
      this.checkbox = false;
      if (this.clienteSelected == "" || this.clienteSelected == "T" ||
        // this.cultivoSelected == "" || this.cultivoSelected == "T" ||
        this.semanaSelected == "" || this.semanaSelected == "T"
        // || this.zonaSelected == "" || this.zonaSelected == "T"
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: 'CoffeeIcon',
            text: "Debe Seleccionar Correctamente los Datos a Filtrar",
            variant: 'warning'
          }
        })
      } else if (this.items.length == 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Error`,
            icon: 'CoffeeIcon',
            variant: 'warning',
            text: `No Existen Datos para enviar`,
          },
        })
      } else {
        this.cargarClientes()
        this.cargarDatosFiltrados()
        this.estadoModal = true
        this.infoModal.title = 'Enviar Correo'
        this.infoModal.boton = 'Enviar'
      }

    },
    cargarDatosFiltrados() {
      var cult_eng = ""
      if (this.cultivoSelected == "ARANDANO CONV.") {
        cult_eng = "CONVENTIONAL BLUEBERRY"
      } else if (this.cultivoSelected == "ARANDANO ORGANICO") {
        cult_eng = "ORGANIC BLUEBERRY"
      } else if (this.cultivoSelected == "ESPARRAGO") {
        cult_eng = "ASPARAGUS"
      } else if (this.cultivoSelected == "UVA") {
        cult_eng = "GRAPE"
      } else {
        cult_eng = this.cultivoSelected
      }


      this.asunto = 'AGROVISION SHIPMENT REPORT WK ' + this.semanaSelected.substring(4, 6) + ' / ' + this.clienteSelected;
      this.contenido = "Dear Sirs,\nWe are pleased to inform you the details of merchandising dispatched as attached:\n\nSHIPPER:  AGROVISION PERU S.A.C.\nCUSTOMER: " + this.clienteSelected + "\nCROP: " + cult_eng + "\nWK: " + this.semanaSelected.substring(4, 6) + "\n\nNote:\nWhen sending final sales reports or liquidations please add sales@agrovisioncorp.com to the list of recipients.\n\nGracias & Saludos / Thanks & Rgds.";

    },
    cargarClientes() {
      this.emailOpt = [];
      this.correoSelected = "";
      let cliente = "";
      cliente = this.clienteSelected
      if (cliente == "") {
        cliente = "T"
      }
      for (let value of this.correosAll) {
        if (value.name1 == this.clienteSelected) {
          this.emailOpt.push({ value: value.correo_oficial, text: value.correo_oficial })
        }
      }
      for (let index = 0; index < this.emailOpt; index++) {
        const element = array[index];
      }
    },

    enviarFormulario() {

      if (this.destinosOpt.length <= 0) {
        this.$swal.fire('Mensaje', 'Ingrese un correo válido!', 'warning').then((result) => { });
        return;
      }
      // Exit when the form isn't valid
      // if (!this.validarFormulario()) {
      //   return 0;
      // }

      // Hide the modal manually
      this.$nextTick(() => {
        var yo = this

        var contenido = this.contenidoHtml();
        var correos = "";
        // this.destinosOpt.push({ value: "meysi.limo@agrovisioncorp.com", text: "meysi.limo@agrovisioncorp.com" })
        for (var i = 0; i < this.destinosOpt.length; i++) {
          correos = correos + this.destinosOpt[i].value + "[-@@-]";
        }

        yo.loadingCorreo = true;

        var cliente = yo.clienteSelected;
        var cultivo = yo.cultivoSelected;
        var semana = yo.semanaSelected;
        var zona = yo.zonaSelected;
        if (cliente == '') cliente = 'T';
        if (cultivo == '') cultivo = 'T';
        if (semana == '') semana = 'T';
        if (zona == '') zona = 'T';

        var qs = require('qs');
        var data = qs.stringify({
          "correo": correos,
          "asunto": yo.asunto,
          "text_content": yo.contenido,
          "html_content": this.miHtml,
          "cliente": cliente,
          "cultivo": cultivo,
          "semana": semana,
          "zona": zona

        });



        var url = "/comex/shippingadvice/enviarcorreo/"

        var config = {
          method: 'post',
          url: url,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: data
        };

        axiosIns(config)
          .then(function (response) {

            if (response.status === 201 || response.status === 200) {

              let resul = response.data;

              if (resul.enviado == 'si') {
                yo.mostrarNotificacion('Correo enviado con éxito', 'CheckIcon', 'El correo ' + '' + ' ha sido enviado correctamente', 'success')
              } else {
                yo.mostrarNotificacion('Error de enviado', 'AlertCircleIcon', 'El correo no se pudo enviar, Revisar Error' + '"' + resul.mensaje + '"', 'warning')
              }

            } else {
              yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
          }).finally(function () {
            yo.loadingCorreo = false;


          });

        this.estadoModal = false
      })


      // Hide the modal manually
    },




    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },
    agregarCorreo() {
      var yo = this;
      if (this.correoSelected == '', this.correoSelected.indexOf("@") <= 0) {
        yo.$swal.fire('Mensaje', 'Ingrese un correo válido!', 'warning').then((result) => { })
        return;
      }
      yo.destinosOpt.push({ value: this.correoSelected, text: this.correoSelected })
      yo.destinosSelected = this.correoSelected;
      this.correoSelected = '';

    },
    eliminarCorreo() {
      var yo = this;
      yo.y = 0;
      if (yo.destinosSelected != null) {
        for (let correo of yo.destinosOpt) {
          if (correo.value === yo.destinosSelected) {
            yo.destinosOpt.splice(yo.y, 1)
            yo.destinosSelected = "";
          }
          yo.y++;
        }
      }
    },

    resetModal() {
      this.correo = ''
      this.destinosSelected = ''
      // this.asunto = ''
      // this.contenido = ''
      // this.nomnbres_remitente = ''
      // this.apellidos_remitente = ''
      // this.telefono = ''
      // this.correo_remitente = ''

      this.validacion = null
      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },
    mostrarNotificacion(titulo, icono, texto, variante) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
        {
          timeout: 5000
        })
    },

    contenidoHtml() {
      let result = this.contenido.replaceAll("\n", "<br>");
      result = result.replace("SHIPPER:", "<b>SHIPPER:</b>");
      result = result.replace("CUSTOMER:", "<b>CUSTOMER:</b>");
      result = result.replace("CROP:", "<b>CROP:</b>");
      result = result.replace("WK:", "<b>WK:</b>");
      result = result.replace("Note:", "<b>Note:</b>");

      this.miHtml = "<div>\n" +
        "           <div>\n" +
        "             <p>" + result + "</p>\n" +
        "           </div>\n" +
        "         </div>";


    }

  },
}
</script>

<style lang="scss">
.alinear-una-sola-linea {
  white-space: nowrap !important;
}
</style>
